export function initGlobalMenu($) {
  if (!$) return;

  const mediaQuery = window.matchMedia('(max-width: 1023px)');

  const onChange = (e) => {
    handleGlobalMenu(e, $);
  };

  // 初回実行
  handleGlobalMenu(mediaQuery, $);

  // 画面幅変更時
  mediaQuery.addEventListener('change', onChange);
}

function handleGlobalMenu(mq, $) {
  if (mq.matches) {
    // SP用のPCイベントを解除
    $('.fade > li').off('.globalMenu');

    // 初期状態
    $('.navbar-collapse').hide();

    // メニュー開閉
    $('.navbar-toggle, .close-btn')
      .off('click.globalMenu')
      .on('click.globalMenu', function () {
        $('.navbar-collapse').stop(true, true).slideToggle(300, 'swing');
        $('.menu-btn').toggleClass('menu-open');
      });

    // サブメニュー開閉
    $('.gnav-set li > .sub-menu-ttl')
      .off('click.globalMenu')
      .on('click.globalMenu', function () {
        $(this).next().stop(true, true).slideToggle();
        $(this).find('.arrow').toggleClass('rotate');
      });

    // 背景スクロール停止用クラス
    $('.menu-btn')
      .off('click.globalMenu')
      .on('click.globalMenu', function () {
        $(this).toggleClass('stop');
      });
  } else {
    // PC用のSPイベントを解除
    $('.navbar-toggle, .close-btn').off('click.globalMenu');
    $('.gnav-set li > .sub-menu-ttl').off('click.globalMenu');
    $('.menu-btn').off('click.globalMenu');

    // SP用のインラインstyleをリセット
    $('.navbar-collapse').removeAttr('style');

    // PCホバー開閉
    $('.fade > li')
      .off('.globalMenu')
      .on('mouseenter.globalMenu', function () {
        $(this).find('.sub-menu').stop(true, true).fadeIn(300);
      })
      .on('mouseleave.globalMenu', function () {
        $(this).find('.sub-menu').stop(true, true).fadeOut(300);
      });
  }
}
